import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { useContext, useEffect, useState } from "react";
import { ClienteContext } from "../contexts/ClienteContext";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";

const listTypePix = [
  { label: "CPF/CNPJ" },
  { label: "Telefone" },
  { label: "E-mail" },
  { label: "Outros" },
];

export default function ModalClienteInfoBancaria({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais
    generalCustomerId,

    bankInformations,
    setBankInformations,

    listBank,
    loadingInputs,
  } = useContext(ClienteContext);

  const [bank, setBank] = useState(null);
  const [agency, setAgency] = useState("");
  const [agencyDigit, setAgencyDigit] = useState("");
  const [account, setAccount] = useState("");
  const [accountDigit, setAccountDigit] = useState("");
  const [pixKeyType, setPixKeyType] = useState(null);
  const [pixKey, setPixKey] = useState("");
  const [mainCheck, setMainCheck] = useState(false);
  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit) return;

    const { data } = rowEdit;

    setAgency(data.agencia || "");
    setAgencyDigit(data.agencia_digito || "");
    setAccount(data.conta || "");
    setAccountDigit(data.conta_digito || "");
    setPixKeyType(
      listTypePix.find((type) => type.label === data.tipo_pix) || null
    );
    setPixKey(data.chave_pix || "");
    setMainCheck(data.conta_padrao || false);
  }, [rowEdit]);

  useEffect(() => {
    if (!rowEdit?.data?.codigo_banco) return;

    setBank(
      listBank.find((option) => option.codigo === rowEdit.data.codigo_banco)
    );
  }, [rowEdit, listBank]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const resultValidation = validNotNull([{ key: "bank", value: bank }]);

    setErrorsModal(resultValidation.errorsValidation);
    if (resultValidation.error)
      return notify("Verifique se os campos estão preenchidos corretamente.");

    let copyBankInformations = [...bankInformations];

    const body = {
      codigo_banco: bank?.codigo,
      agencia: agency,
      agencia_digito: agencyDigit,
      conta: account,
      conta_digito: accountDigit,
      chave_pix: pixKey,
      conta_padrao: mainCheck,
      tipo_pix: pixKeyType ? pixKeyType.label : null,
    };

    if (mainCheck) {
      copyBankInformations = copyBankInformations.map((item) => ({
        ...item,
        conta_padrao: false,
      }));
    }

    if (generalCustomerId) body.id_cliente = generalCustomerId;

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...copyBankInformations];
        copy[rowEdit.index] = body;
        setBankInformations(copy);
      }
    } else {
      setBankInformations([...copyBankInformations, body]);
    }

    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Contas{rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={2} md={4} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs.listBank || false}
                helperText={errorsModal.bank}
                error={errorsModal.bank ? true : false}
                label="Banco*"
                value={bank}
                setValue={setBank}
                optionsList={listBank}
                descriptionField="nome"
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Agência"
                maxLength={15}
                value={agency}
                setValue={setAgency}
                type="number"
              />
            </Grid>

            <Grid item lg={2} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Agência Digito"
                maxLength={15}
                value={agencyDigit}
                setValue={setAgencyDigit}
                type="number"
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Conta"
                maxLength={15}
                value={account}
                setValue={setAccount}
                type="number"
              />
            </Grid>

            <Grid item lg={2} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Conta Digito"
                maxLength={15}
                value={accountDigit}
                setValue={setAccountDigit}
                type="number"
              />
            </Grid>

            <Grid item lg={2} md={4} sm={6} xs={12}>
              <SelectErp
                loading={false}
                label="Tipo Chave PIX"
                value={pixKeyType}
                setValue={setPixKeyType}
                optionsList={listTypePix}
                descriptionField="label"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Chave PIX"
                maxLength={80}
                value={pixKey}
                setValue={setPixKey}
              />
            </Grid>

            <Grid item flex={1}>
              <FormControlLabel
                control={
                  <Switch
                    checked={mainCheck}
                    onChange={() => setMainCheck((current) => !current)}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="Conta Principal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
